import { Icon } from '@chakra-ui/react';

export default function SFApplePencil(props) {
  return (
    <Icon
      width='20px'
      height='20px'
      viewBox='0 0 20 20'
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      {...props}
    >
      <path
        d='M5.66399 13.685L5.87232 13.3139L13.802 5.42326C14.1145 5.11076 14.6223 5.11076 14.9413 5.42978C15.2603 5.74228 15.2603 6.2566 14.9413 6.57561L7.01815 14.4597L6.63404 14.6615L5.66399 13.685ZM4.83716 15.1824L5.36451 14.2384L6.07414 14.948L5.09758 15.4558C4.94133 15.5405 4.73951 15.3712 4.83716 15.1824Z'
        fill='currentColor'
      />
    </Icon>
  );
}
